// extracted by mini-css-extract-plugin
module.exports = {"container":"_2ykd4","spinner":"_1b2kX","spin":"_1LdZ0"};